import { render, staticRenderFns } from "./perturbSeq.vue?vue&type=template&id=0f380a78&"
import script from "./perturbSeq.vue?vue&type=script&lang=js&"
export * from "./perturbSeq.vue?vue&type=script&lang=js&"
import style0 from "./perturbSeq.vue?vue&type=style&index=0&id=0f380a78&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports